import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './ClientsTab';
import Form from './ClientForm';

function ClientsRouter() {
  return (
    <Switch>
      <Route exact path="/clients" component={Tab} />
      <Route exact path="/clients/new" component={Form} />
      <Route exact path="/clients/:id" component={Form} />
      <Redirect to="/clients" />
    </Switch>
  );
}

export default ClientsRouter;



// WEBPACK FOOTER //
// ./src/containers/Clients/index.js